import React from 'react';
import { RichUtils } from 'draft-js';
import {
  AiOutlineBold,
  AiOutlineItalic,
  AiOutlineUnderline,
} from 'react-icons/ai';
import { eventNames } from '../../../../config';
import BaseGroupBlock from '../BaseGroupBlock';

const items = [
  {
    inlineStyle: 'BOLD',
    tooltipTitle: 'Полужирный',
    children: <AiOutlineBold />,
  },
  {
    inlineStyle: 'ITALIC',
    tooltipTitle: 'Курсив',
    children: <AiOutlineItalic />,
  },
  {
    inlineStyle: 'UNDERLINE',
    tooltipTitle: 'Подчеркнутый',
    children: <AiOutlineUnderline />,
  },
];
const isActive = (watchedValue, value) => watchedValue.has(value);
const InlineStyleGroupBlock = () => {
  return (
    <BaseGroupBlock
      items={items}
      evtName={eventNames.inlineStyleChange}
      isActive={isActive}
      getNewState={RichUtils.toggleInlineStyle}
    />
  );
};

export default InlineStyleGroupBlock;
